import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '@app/environment';
import { GraphQLService } from '@app/services';
import { 
    queryMatch, mutationValidateMatch, mutationValidateMatchWithCode
} from '@app/graphql-queries';
import { Match } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class MatchService {
    
    constructor(
        private httpClient: HttpClient,
        public translateService: TranslateService,
        private graphQLService: GraphQLService
    ) { }
    
    async fetchMatch(matchID: string): Promise<Match|null> {
        let match: Match|null = null;
        let response = await this.graphQLService.query({
            query: queryMatch,
            variables: {
              ID: matchID
            },
            fetchPolicy: 'no-cache' 
        },'public');      
        if(response?.data?.Match){
            match = response.data.Match;
            if(match?.challengeSales){
                match.challengeSales.type = 'sale';
                match.challengeSales.title = this.translateService.instant('CHALLENGE_RESPONSE.SALE_TITLE');
                match.challengeSales.description = this.translateService.instant('CHALLENGE_RESPONSE.SALE_DESCRIPTION').replace('{owner}', match.owner?.firstName+' '+match.owner?.lastName);
            }
        }
        return match;
    }
    
    async validateMatch(matchID: string): Promise<boolean> {
        let status: boolean = false;
        let response = await this.graphQLService.mutate({   
            mutation: mutationValidateMatch,
            variables: {
                matchID: matchID
            }       
        });     
        if(response?.data?.ValidateMatch){
            status = true;
        }
        return status;
    }
    
    async validateMatchByCode(code: string){
        let status: boolean = false;
        let response = await this.graphQLService.mutate({   
            mutation: mutationValidateMatchWithCode,
            variables: {
                code: code
            }       
        });     
        if(response?.data?.ValidateMatchWithCode){
            status = true;
        }
        return status;
    }
    
    async validateMatchByToken(matchID: string, key: string, token: string, hasValidated: string): Promise<boolean>{
        return new Promise ((resolve) => {           
            let params: any = {
                key: key,
                token: token,
                hasValidated: hasValidated
            };
            this.httpClient.get(environment.URL_API_BACKEND_REST+'matches/match/'+matchID+'/validate', {params: params}).subscribe(
                (response: any) => { 
                    resolve(response === 'OK');
                },
                () => {
                    resolve(false);
                }
            );            
        });
    }
}
